<template>
  <div :class="['text-field', { 'is-invalid': showValidationError }]">
    <label v-if="label && showLabel" :for="inputId" class="form-label">
      <required v-if="required" />
      <span v-html="label" />
    </label>
    <textarea v-if="multiline" :id="inputId" ref="input" :rows="rows" :disabled="disabled"
              :minlength="minLength" :maxlength="maxLength" :readonly="readonly"
              :class="['task-editor-text-input form-control', additionalInputClasses, {'is-invalid': showValidationError}]"
              :value="value" :name="inputName" @input="setText" @focus="$emit('focus')" @blur="$emit('blur')" />
    <input v-else :id="inputId" ref="input" :type="inputType" :autocomplete="autocomplete"
           :disabled="disabled" :readonly="readonly" :minlength="minLength" :maxlength="maxLength"
           :class="['task-editor-text-input form-control', additionalInputClasses, {'is-invalid': showValidationError}]"
           :value="value" :name="inputName" :placeholder="placeholder"
           @input="setText" @focus="$emit('focus')" @blur="$emit('blur')">

    <slot name="help-text">
      <small v-if="helpText" class="form-text text-muted" v-html="helpText" />
    </slot>

    <validation-errors v-if="showValidationError" :errors="validationErrors" />
  </div>
</template>

<script>
import Required from '../required'
import ValidationErrors from './validation-errors'

export default {
  components: { Required, ValidationErrors },

  props: {
    value: {
      type: [String, Number],
      required: false
    },
    multiline: {
      type: Boolean,
      required: false,
      default: false
    },
    validationErrors: {
      type: Array,
      required: false
    },
    additionalInputClasses: {
      type: String,
      required: false
    },
    autocomplete: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    helpText: {
      type: String,
      required: false
    },
    inputId: {
      type: String,
      required: false
    },
    inputName: {
      type: String,
      required: false
    },
    inputType: {
      type: String,
      required: false,
      default: 'text'
    },
    label: {
      type: String,
      required: false
    },
    maxLength: {
      type: Number,
      required: false
    },
    minLength: {
      type: Number,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    rows: {
      type: Number,
      required: false,
      default: 3
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['blur', 'changed', 'focus'],

  computed: {
    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  methods: {
    focus() {
      this.$refs.input.focus()
    },

    setText(e) {
      this.$emit('changed', e.target.value)
    }
  }
}
</script>
